import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PushPipe } from '@ngrx/component';
import { WdxButtonModule } from '@wdx/shared/components/wdx-button';
import { WdxFormFieldModule } from '@wdx/shared/components/wdx-form-field';
import { WdxIconModule } from '@wdx/shared/components/wdx-icon';
import { WdxInfoCardModule } from '@wdx/shared/components/wdx-info-card';
import { WdxInputGroupModule } from '@wdx/shared/components/wdx-input-group';
import { WdxInputTextModule } from '@wdx/shared/components/wdx-input-text';
import { FunctionPipe, TranslateTokenisedStringPipe } from '@wdx/shared/utils';
import { AtomAddButtonModule } from '../../../components/atoms/atom-add-button/atom-add-button.module';
import { AtomAsyncDataModule } from '../../../components/atoms/atom-async-data/atom-async-data.module';
import { AtomInputNoneSelectedModule } from '../../../components/atoms/atom-input-none-selected/atom-input-none-selected.module';
import { AtomModalWrapperModule } from '../../../components/atoms/atom-modal-wrapper/atom-modal-wrapper.module';
import { MoleculeAvatarGroupModule } from '../../../components/molecules/molecule-avatar-group/molecule-avatar-group.module';
import { MoleculeInfoCardSearchModule } from '../../../components/molecules/molecule-info-card-search/molecule-info-card-search.module';
import { OrganismModalModule } from '../../../components/organisms/organism-modal/organism-modal.module';
import { DirectivesModule } from '../../../directives/directives.module';
import { MoleculeInputSearchModule } from '../molecule-input-search/molecule-input-search.module';
import { MoleculeInputLookupDumbComponent } from './components/molecule-input-lookup-dumb/molecule-input-lookup-dumb.component';
import { MoleculeInputLookupComponent } from './containers/molecule-input-lookup/molecule-input-lookup.component';

@NgModule({
    imports: [
        AtomAddButtonModule,
        AtomAsyncDataModule,
        AtomInputNoneSelectedModule,
        AtomModalWrapperModule,
        CommonModule,
        DirectivesModule,
        FormsModule,
        MoleculeAvatarGroupModule,
        MoleculeInfoCardSearchModule,
        MoleculeInputSearchModule,
        OrganismModalModule,
        PushPipe,
        WdxFormFieldModule,
        WdxInfoCardModule,
        FunctionPipe,
        TranslateTokenisedStringPipe,
        WdxButtonModule,
        WdxIconModule,
        WdxInputTextModule,
        WdxInputGroupModule,
    ],
    declarations: [
        MoleculeInputLookupComponent,
        MoleculeInputLookupDumbComponent,
    ],
    exports: [MoleculeInputLookupComponent, MoleculeInputLookupDumbComponent],
})
export class MoleculeInputLookupModule {}
